import { Component } from '@angular/core';
import {AuthHttp} from 'angular2-jwt/angular2-jwt';
import { AuthService } from './auth.service'
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TagService } from './tag.service';
import { FileService } from './file.service';
import { CriterionService } from './criterion.service';
import { NoteService } from './note.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(  //too ensure early initialization
    public utils: UtilsService,
    private auths: AuthService,
    private projects: ProjectService,
    private tags: TagService,
    private cs: CriterionService,
    private fs: FileService,
    private ns: NoteService
  ) {
    addEventListener("message", (event) => {
    if (event.origin != "https://gae-test.ecomole.com")
      return
    if (event.data['app'] != 'searchman')
      return
    event.data['stats'].forEach((x) => this.fs.newFromSaved(x, true))
  }, false)
  }

  get isAdmin() {
    if (!this.utils)
      return false
    return this.utils.isAdmin
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/app.component.ts